import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { errMsg } from "@/lib/api";
import { UseButton } from "./PointsBox";

const pinInput = (value, onChange, testId, placeholder) => (
  <Input type="password" inputMode="numeric" autoComplete="off" maxLength={4} value={value} placeholder={placeholder}
    onChange={(e) => onChange(e.target.value.replace(/\D/g, "").slice(0, 4))} className="bg-white text-center text-lg tracking-[0.5em]" data-testid={testId} />
);

export function PinGate({ wallet, http, phone, label, color, onOk }) {
  const [open, setOpen] = useState(false);
  const [pin, setPin] = useState("");
  const [pin2, setPin2] = useState("");
  const [busy, setBusy] = useState("");
  const [msg, setMsg] = useState("");
  const create = !wallet.has_pin;
  if (!open) return <UseButton label={label} onClick={() => setOpen(true)} color={color} />;
  const go = async () => {
    if (pin.length !== 4) return setMsg("A senha tem 4 números");
    if (create && pin !== pin2) return setMsg("As duas senhas não são iguais");
    setBusy("pin"); setMsg("");
    try { await http.post("/loyalty/pin", { phone, pin, action: create ? "create" : "check" }); onOk(pin); } catch (e) { setMsg(errMsg(e)); }
    return setBusy("");
  };
  const remind = async () => {
    setBusy("remind"); setMsg("");
    try { const { data } = await http.post("/loyalty/pin/remind", { phone }); toast.success(`Enviamos uma nova senha para o seu WhatsApp (${data.sent_to})`); } catch (e) { setMsg(errMsg(e)); }
    setBusy("");
  };
  return (
    <div className="space-y-3 rounded-xl border p-3" style={{ borderColor: color }} data-testid="shop-pin-panel">
      <p className="flex items-center gap-2 font-semibold"><KeyRound className="h-4 w-4" style={{ color }} />{create ? "Finalize seu cadastro de pontos" : "Digite sua senha dos pontos"}</p>
      <p className="text-xs text-slate-500">{create ? "Crie uma senha de 4 números. Você vai usar essa senha sempre que for trocar seus pontos." : "É a senha de 4 números que você criou para usar os pontos."}</p>
      <div className={create ? "grid grid-cols-2 gap-2" : ""}>
        {pinInput(pin, setPin, "shop-pin-input", create ? "Senha" : "••••")}
        {create && pinInput(pin2, setPin2, "shop-pin-confirm-input", "Repita")}
      </div>
      {msg && <p className="text-sm text-red-600" data-testid="shop-pin-error">{msg}</p>}
      <div className="grid grid-cols-2 gap-2">
        <Button type="button" variant="outline" className="bg-white" onClick={() => { setOpen(false); setMsg(""); }} data-testid="shop-pin-cancel">Cancelar</Button>
        <Button type="button" className="text-white" style={{ background: color }} disabled={!!busy} onClick={go} data-testid="shop-pin-submit">{busy === "pin" && <Loader2 className="mr-1 h-4 w-4 animate-spin" />}{create ? "Criar senha" : "Continuar"}</Button>
      </div>
      {!create && (
        <button type="button" onClick={remind} disabled={!!busy} className="flex items-center gap-1 text-xs font-semibold hover:underline" style={{ color }} data-testid="shop-pin-remind">
          {busy === "remind" && <Loader2 className="h-3 w-3 animate-spin" />}Lembrar senha (enviamos uma nova no seu WhatsApp)
        </button>
      )}
    </div>
  );
}
